import { render, staticRenderFns } from "./leftSide.vue?vue&type=template&id=77f0a2c8&scoped=true&"
import script from "./leftSide.vue?vue&type=script&lang=js&"
export * from "./leftSide.vue?vue&type=script&lang=js&"
import style0 from "./leftSide.vue?vue&type=style&index=0&id=77f0a2c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f0a2c8",
  null
  
)

export default component.exports